import { ADD_CLOSEST_LVZ_INFO, RESET_CLOSEST_LVZ_INFO} from "./closestLvzInfoReducer"

export const addClosestLvzInfo = (data) => ({
    type: ADD_CLOSEST_LVZ_INFO,
    payload: data
})

export const resetClosestLvzInfo = () => ({
    type: RESET_CLOSEST_LVZ_INFO,
})